// Configuración base de firebase en proyecto para el registro
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY_PRD,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN_PRD,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID_PRD,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET_PRD,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID_PRD,
  appId: process.env.VUE_APP_FIREBASE_APP_ID_PRD
}

const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
